import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ReduxStore } from '../../../store/reducers';
import ImageGallery, { ReactImageGalleryItem } from 'react-image-gallery';
import { Photo } from '../../shared/Photo/Photo';
import { IObservationServiceObj } from '../../../shared/apiServices/IApiInterfaces';

interface ICarouselProps {
  observationObj: IObservationServiceObj;
}

const Carousel = (props: ICarouselProps) => {
  const [images, setImages] = useState<ReactImageGalleryItem[]>();

  useEffect(() => {
    const photos = props.observationObj?.photoUrls?.map((i) => {
      return {
        original: i,
        renderItem: () => {
          return (
            <Photo
              observationId={props.observationObj.id}
              url={i}
              height="100%"
            />
          );
        },
      };
    });
    setImages(photos);
  }, [props.observationObj]);

  return (
    <ImageGallery
      items={images ?? []}
      showBullets={true}
      showFullscreenButton={false}
      showPlayButton={false}
      showThumbnails={false}
    />
  );
};

const stateToProps = (state: ReduxStore) => {
  return { observationObj: state.Observation.ObservationObject };
};

export default connect(stateToProps)(Carousel);
